// B241 FASE 2 (AI_109) — Rótulo/unidade dos campos de SOROLOGIAS, para a
// TELA DE CONFERÊNCIA da importação por PDF (entrada única em Exames Lab).
//
// As CHAVES são as mesmas do backend (api/_lib/dicionarioSorologias.js) e de
// `SorologiaViral`. Valores são TEXTO e em geral QUALITATIVOS
// (Reagente/Não reagente, Detectável/Indetectável, título, genótipo, carga
// viral) → gravados como string, sem conversão numérica.

import { RotuloCampo } from "./camposMarcadores";

export const CAMPOS_SOROLOGIAS_ROTULO: Record<string, RotuloCampo> = {
  // Hepatite B
  hbsag: { label: "HBsAg", unidade: "" },
  antiHBs: { label: "Anti-HBs", unidade: "mUI/mL" },
  antiHBcIgG: { label: "Anti-HBc IgG / total", unidade: "" },
  antiHBcIgM: { label: "Anti-HBc IgM", unidade: "" },
  hbeag: { label: "HBeAg", unidade: "" },
  antiHBe: { label: "Anti-HBe", unidade: "" },
  genotipagemVHB: { label: "Genótipo VHB", unidade: "" },
  pcrVHB: { label: "PCR/DNA VHB (carga viral)", unidade: "UI/mL" },
  // Hepatite C
  antiHCV: { label: "Anti-HCV", unidade: "" },
  hcvRNA: { label: "HCV-RNA (carga viral)", unidade: "UI/mL" },
  // Hepatite A
  antiHAVIgG: { label: "Anti-HAV IgG / total", unidade: "" },
  antiHAVIgM: { label: "Anti-HAV IgM", unidade: "" },
  // Hepatite D/E
  antiHDV: { label: "Anti-HDV / anti-delta", unidade: "" },
  pcrVHD: { label: "PCR/RNA VHD (carga viral)", unidade: "UI/mL" },
  antiHEV: { label: "Anti-HEV", unidade: "" },
  // CMV
  cmvIgG: { label: "CMV IgG", unidade: "" },
  cmvIgM: { label: "CMV IgM", unidade: "" },
  cmvPCR: { label: "CMV-PCR (carga viral)", unidade: "UI/mL" },
  // EBV
  ebvIgG: { label: "EBV IgG (VCA)", unidade: "" },
  ebvIgM: { label: "EBV IgM (VCA)", unidade: "" },
  ebvPCR: { label: "EBV-PCR (carga viral)", unidade: "UI/mL" },
  // Rubéola
  rubeolaIgG: { label: "Rubéola IgG", unidade: "" },
  rubeolaIgM: { label: "Rubéola IgM", unidade: "" },
  // Outros
  antiHIV: { label: "Anti-HIV (1/2)", unidade: "" },
  vdrl: { label: "VDRL / RPR", unidade: "" },
  ftaAbs: { label: "FTA-ABS", unidade: "" },
  toxoIgG: { label: "Toxoplasmose IgG", unidade: "" },
  toxoIgM: { label: "Toxoplasmose IgM", unidade: "" },
  chagasIgG: { label: "Chagas IgG", unidade: "" },
  chagasIgM: { label: "Chagas IgM", unidade: "" },
  chagas: { label: "Chagas (geral)", unidade: "" },
  htlv: { label: "HTLV I/II", unidade: "" },
  // Rastreio pré-Tx — parasitas / tuberculose (AI_118)
  estrongiloidesIgG: { label: "Estrongiloides IgG", unidade: "" },
  igraTB: { label: "IGRA / Quantiferon-TB", unidade: "" },
  ppd: { label: "PPD (tuberculina)", unidade: "mm" },
};

export function rotuloCampoSorologia(campo: string): RotuloCampo {
  return CAMPOS_SOROLOGIAS_ROTULO[campo] || { label: campo, unidade: "" };
}
